import * as RadixSwitch from '@radix-ui/react-switch';
import { cj, cm } from 'src/utils/classNames';

export interface Props extends Pick<
	RadixSwitch.SwitchProps,
	| 'asChild'
	| 'defaultChecked'
	| 'checked'
	| 'onCheckedChange'
	| 'disabled'
	| 'required'
	| 'name'
	| 'value'
	| 'className'
> {
	size: 'sm' | 'md';
	dataTestId?: string;
}

export default function Switch({
	size,
	checked,
	onCheckedChange,
	className,
	disabled,
	dataTestId,
	...rest
}: Props) {
	const rootSizeClassName = {
		sm: 'w-[30px] h-[18px]',
		md: 'w-10 h-6',
	}[size];

	const thumbSizeClassName = {
		sm: 'size-3 data-[state=checked]:translate-x-[15px] translate-x-[3px]',
		md: 'size-4 data-[state=checked]:translate-x-[20px] translate-x-[4px]',
	}[size];

	return (
		<RadixSwitch.Root
			checked={checked}
			onCheckedChange={onCheckedChange}
			disabled={disabled}
			data-testid={dataTestId}
			className={cm(
				'relative cursor-pointer rounded-full transition-colors',
				rootSizeClassName,
				checked ? 'bg-button-primary-bg' : 'bg-text-tertiary',
				'data-disabled:cursor-not-allowed data-disabled:bg-stroke-divider',
				className
			)}
			{...rest}
		>
			<RadixSwitch.Thumb
				className={cj(
					'block rounded-full bg-container-bg transition-transform',
					'data-disabled:bg-text-disabled',
					thumbSizeClassName
				)}
			/>
		</RadixSwitch.Root>
	);
}
